import { render, staticRenderFns } from "./AppDurationField.vue?vue&type=template&id=3fca615a"
import script from "./AppDurationField.vue?vue&type=script&lang=js"
export * from "./AppDurationField.vue?vue&type=script&lang=js"
import style0 from "./AppDurationField.vue?vue&type=style&index=0&id=3fca615a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports